import TextField from '../TextField/TextField';
import * as React from 'react';
import { useEffect, useState } from 'react';
import Select from '../Select/Select';

interface GlycaemiaProps {
	onChange?: (values: GlycaemiaValues) => void;
	value?: any;
	disabled?: boolean;
}

export interface GlycaemiaValues {
	value: number;
	unit: string;
}

const Glycaemia: React.FC<GlycaemiaProps> = props => {
	const { onChange, value, disabled } = props;
	const [tempValue, setTempValue] = useState<number>(0);
	const [tempUnit, setTempUnit] = useState<string>('mg/DL');

	useEffect(() => {
		onChange?.({ value: calculate(), unit: 'mg/DL' });
	}, [tempValue, tempUnit]);

	useEffect(() => {
		if (value) {
			if (typeof value === 'object') {
				setTempValue(value.value);
				if (['mg/DL', 'mmol/L'].indexOf(value.unit) !== -1) {
					setTempUnit(value.unit);
				}
			} else {
				setTempValue(value);
			}
		}
	}, []);

	const calculate = () => {
		let val = tempValue;
		if (tempUnit === 'mmol/L') {
			val *= 18;
		}
		return parseInt(val?.toString());
	};

	const handleChangeValue = (val: string) => {
		const intVal = parseInt(val);
		setTempValue(intVal);

		if (intVal >= 0 && intVal <= 15 && tempUnit !== 'mmol/L') {
			handleChangeUnit({ value: 'mmol/L', label: 'mmol/L' });
		}
		if (intVal >= 50 && intVal <= 250 && tempUnit !== 'mg/DL') {
			handleChangeUnit({ value: 'mg/DL', label: 'mg/DL' });
		}
	};

	const handleChangeUnit = (val: { value: string; label: string }) => {
		setTempUnit(val.value);
	};

	return (
		<div className='d-flex flex-row align-items-center' style={{ gap: '15px' }}>
			<div style={{ flexGrow: 1 }}>
				<TextField
					disabled={disabled}
					onChange={handleChangeValue}
					value={isNaN(tempValue) ? '' : tempValue.toString()}
				/>
			</div>
			<Select
				disabled={disabled}
				options={[
					{ value: 'mg/DL', label: 'mg/DL' },
					{ value: 'mmol/L', label: 'mmol/L' },
				]}
				value={tempUnit}
				onChange={handleChangeUnit}
			/>
		</div>
	);
};

export default Glycaemia;
